import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Cargar tema guardado o usar el preferido del sistema
    const savedTheme = localStorage.getItem('theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const theme = savedTheme || (prefersDark ? 'dark' : 'light')
    
    this.setTheme(theme)
    
    // Escuchar cambios en la preferencia del sistema
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (!localStorage.getItem('theme')) {
        this.setTheme(e.matches ? 'dark' : 'light')
      }
    })
  }

  toggle() {
    const currentTheme = document.documentElement.getAttribute('data-theme') || 'light'
    const newTheme = currentTheme === 'light' ? 'dark' : 'light'
    this.setTheme(newTheme)
    localStorage.setItem('theme', newTheme)
  }

  setTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme)
    
    // Broadcast theme change to all iframe windows (Caja module)
    document.querySelectorAll('iframe.window-iframe').forEach(iframe => {
      try {
        iframe.contentWindow?.postMessage(
          { type: 'theme:change', theme },
          window.location.origin
        )
      } catch (e) {
        // Ignore cross-origin errors
      }
    })
    
    // Actualizar el ícono del botón
    const iconElement = this.element.querySelector('.theme-icon')
    if (iconElement) {
      iconElement.innerHTML = theme === 'dark' 
        ? this.getSunIcon() 
        : this.getMoonIcon()
    }
  }

  getMoonIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" />
      </svg>
    `
  }

  getSunIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
      </svg>
    `
  }
}
